import { id, project, createTaskError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  error: createTaskError,
  project: { ...project, uuid: id },
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isSuccessful: true },
    error: initialState.error,
  };
}

function handleFailure(
  state: State,
  { error }: Boundaries["createTask"]["failure"],
): State {
  return {
    ...state,
    error,
    request: { ...initialState.request, isFailure: true },
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createTaskRequested]: handleRequest,
    [events.createTaskSucceeded]: handleSuccess,
    [events.createTaskFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
